import React, { useCallback } from "react";
import { Col, Form, Row } from "antd";
import { t, Trans } from "@lingui/macro";
import CountrySelect from "../../Select/Country";
import ToggleToEdit from "../../ToggleToEdit";
import { connect } from "react-redux";
import PublicListActions from "bukku/redux/PublicList/actions";

const { readPublicCountriesList } = PublicListActions;

export const CountriesFormItem = connect(null, { readPublicCountriesList })(
    props => {
        const {
            readPublicCountriesList,
            size,
            keepOpenAfterToggle,
            onToggleOpen,
        } = props;

        const renderNotToggled = useCallback(
            toggleOpen => (
                <Row type="flex">
                    <Col span={24} style={{ fontSize: 13 }}>
                        <Trans>
                            {/* eslint-disable-next-line react/jsx-one-expression-per-line */}
                            Home country is set to <strong>Malaysia</strong>.
                        </Trans>
                        &nbsp;
                        <span
                            className="link"
                            onClick={() => {
                                toggleOpen();
                                readPublicCountriesList();
                            }}
                        >
                            <Trans>Change</Trans>
                        </span>
                        <Form.Item name="country_code" initialValue="MY" noStyle>
                            <span />
                        </Form.Item>
                    </Col>
                </Row>
            ),
            [readPublicCountriesList],
        );

        const formItem = (
            <Row type="flex">
                <Col span={24}>
                    <Form.Item
                        name="country_code"
                        label={t`Home Country`}
                        rules={[{
                            required: true,
                            message: t`The country is required.`,
                        }]}
                        initialValue="MY"
                    >
                        <CountrySelect
                            popupContainerId="parentElement"
                            placeholder={t`Select Country`}
                            hasValue
                            size={size || 'medium'}
                            isPublic
                        />
                    </Form.Item>
                </Col>
            </Row>
        );

        // used in partner create client modal, to keep the form item in edit mode
        if (keepOpenAfterToggle)
            return formItem;

        return (
            <ToggleToEdit
                renderNotToggled={renderNotToggled}
                onToggleOpen={onToggleOpen}
            >
                {formItem}
            </ToggleToEdit>
        );
    },
);
